import CloudBrandTheme from '@sbercloud/figma-tokens-web/build/css/brand.module.css';

import { Theme } from '@/types/theme';

export const themeMap = {
  [Theme.Light]: CloudBrandTheme.light,
  [Theme.Dark]: CloudBrandTheme.dark,
};
